<script setup lang="ts"></script>

<template>
  <NuxtErrorBoundary>
    <AuthForm mode="signin">
      <template #form="{ mode }">
        <SigninForm :mode="mode" />
      </template>
    </AuthForm>

    <template #error="{ error }">
      <Error :error="error" />
    </template>
  </NuxtErrorBoundary>
</template>

<style scoped></style>
